// extracted by mini-css-extract-plugin
module.exports = {"mediumTitleItem":"MediumTitleWithSubText_mediumTitleItem__fyvK3"};